import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu } from 'semantic-ui-react';
import AdminListTable from '../../../components/AdminListTable';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import AdminBanner from '../../../components/elements/AdminBanner';
import { postAsync } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-router-dom';

const ReportList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [next, setNext] = useState(1);
  const [pageNumbers, setPageNumbers] = useState(0);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageCondition, setPageCondition] = useState({
    page: 0,
    currentPage: 0,
  });

  const { t } = useTranslation();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentPosts = apiData.slice(indexOfFirstRecord, indexOfLastRecord);
  const pageCount = Math.ceil(totalPages / recordsPerPage);
  const { pathname } = useLocation()

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])
  const SearchFilter = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
  };
  const getEPUserLoginData = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(`EP_UserAuthentication/GetAllEPUserLoginLogsAsync?page=${currentPage}&pageSize=${recordsPerPage}`, { EPUsername :""})
      .then((response) => {
        setIsLoad(false);
        setPageCondition({
          ...pageCondition,
          page: response.page,
          currentPage: response.currentPage,
        });
        setTotalPages(response.pageCount);
        setApiData(response.data);
        setNext(currentPage);

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    getEPUserLoginData();
  }, []);

  const changePage = async ({ selected }) => {
    let select = selected + 1;
    setPageNumbers(selected);
    await postAsync('GWAService/GetGWAServiceFilterList/' + select + '/' + recordsPerPage, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setApiData(response.data);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const columnsName = ['s.no', 'userName', 'country Name', 'date','time Now']




  return (
    <>
      { !isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>

          <div className="container-fluid pb-96">
            <div className="row justify-center">
              <div className="col-lg-11 text-center pt-9">
                { isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="relative overflow-x-auto  shadow-md sm:rounded-lg">
                        <AdminListTable columnsName={ columnsName } apiData={ apiData } next={ next } recordsPerPage={ recordsPerPage } />
                    { datanotfound && <DataNotFound /> }
                  </div>
                ) }
              </div>
              { pageCount > 0 && (
                <div className="flex flex-row px-12 justify-between">
                  <Menu pagination>
                    <Menu.Item>
                      <ReactPaginate
                        previousLabel={ t('Previous') }
                        nextLabel={ t('Next') }
                        pageCount={ pageCount }
                        onPageChange={ changePage }
                        containerClassName={ 'paginationButtons' }
                        previousLinkClassName={ 'previousButton' }
                        nextLinkClassName={ 'nextButton' }
                        disabledClassName={ 'paginationDisabled' }
                        activeClassName={ 'paginationActive' }
                      />
                    </Menu.Item>
                  </Menu>
                </div>
              ) }
            </div>
          </div>
        </>
      ) }
      ;
    </>
  );
};

export default ReportList;
